import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import figureFormatter from "@/services/utils/figureFormatter";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const rewardPointRegisterPdf = () => {
    const { getHeader, getFooter } = pdfHeaderFooter();
    const { commaFormat } = figureFormatter();

    const exportToPDF = (company, data, totals, userName, qrcode) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(data, totals),
            styles: {
                header: {
                    fontSize: 24
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Reward Point Register'
            }
        }

        pdfMake.createPdf(doc).open();
    }

    const getContent = (data, totals) => {
        return [
            {
                text: 'Reward Point Register',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },
            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    body: getTableBody(data, totals)
                },
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#f3f2f7' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; }
                }
            }
        ]
    }

    const getTableBody = (data, totals) => {
        return [
            getTableHead(),
            ...getTableRows(data),
            getTotalRow(totals)
        ]
    }

    const getTotalRow = (totals) => {
        return [
            { text: 'Total', colSpan: 4, bold: true, alignment: 'right' },
            {}, {}, {},
            { text: commaFormat(totals.opening_balance), bold: true, alignment: 'right' },
            { text: commaFormat(totals.points_earned), bold: true, alignment: 'right' },
            { text: commaFormat(totals.points_redeemed), bold: true, alignment: 'right' },
            { text: commaFormat(totals.closing_balance), bold: true, alignment: 'right' }
        ]
    }

    const getTableHead = () => {
        return [
            { text: 'SL NO' },
            { text: 'ID' },
            { text: 'CUSTOMER NAME' },
            { text: 'MOBILE' },
            { text: 'OPENING BALANCE', alignment: 'right' },
            { text: 'POINT EARNED', alignment: 'right' },
            { text: 'POINT REDEEMED', alignment: 'right' },
            { text: 'CLOSING BALANCE', alignment: 'right' }
        ]
    }

    const getTableRows = (data) => {
        return data.map((item, index) => [
            { text: index + 1 },
            { text: item.serial_no },
            { text: item.name },
            { text: item.mobile_no },
            { text: commaFormat(item.opening_balance), alignment: 'right' },
            { text: commaFormat(item.points_earned), alignment: 'right' },
            { text: commaFormat(item.points_redeemed), alignment: 'right' },
            { text: commaFormat(item.closing_balance), alignment: 'right' }
        ])
    }

    return {
        exportToPDF
    }
}

export default rewardPointRegisterPdf;
